module.exports = __webpack_public_path__ + "media/images/pic/gallery/2019/warsztaty-slodyczy-wagashi-0e56d22d8e7b0bd4e5eadf2d1848d528.jpg";